import { useQuery } from "react-query";

import { reportingService } from "services";

type UseAgentReportsListProps = {
	paidMonth: Date | string;
	paidYear: Date | string;
	fetchData: { page: number; filters: any; sortBy: { [key: string]: any } };
};

const useAgentReportsListQuery = ({
	fetchData,
	paidMonth,
	paidYear,
}: UseAgentReportsListProps) => {
	const { page, filters, sortBy } = fetchData;

	const fetchList = () =>
		reportingService.getAgentReportsList({
			paidMonth,
			paidYear,
			page,
			filters,
			sortBy,
		});

	const queryResult = useQuery(
		["agentReportsList", paidMonth, paidYear, page, filters, sortBy],
		fetchList,
		{
			retry: 0,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useAgentReportsListQuery;
